import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { ContactForm } from '../Contacts/ContactForm';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import "../datatables.css";

export class ContactsTable extends Component {

    constructor(props) {
        super(props);
        this.state = {
            contacts: null,
            deletedContacts: null,
            search: '',
            researcherId: props.researcherId,
            contactId: 0,
            addContactDialogOpen: false,
            editContactDialogOpen: false,
            activeTab: '1',
            formOpen: false,
            dt: null
        };

        this.handleSearchChanged = this.handleSearchChanged.bind(this);
        this.handleSearchSubmit = this.handleSearchSubmit.bind(this);
        this.renderContactsTable = this.renderContactsTable.bind(this);
        this.renderDeletedContactsTable = this.renderDeletedContactsTable.bind(this);
        this.handleContactDeleted = this.handleContactDeleted.bind(this);
        this.deleteTabClicked = this.deleteTabClicked.bind(this);
    }

    componentDidMount() {
        var that = this;
        //not a great way to do this or the react way
        const script = document.createElement("script");
        script.onload = function () {
            that.populateContacts();
        }
        script.src = "js/datatables.min.js"; //this also has jquery included inside since react scopes
        script.async = true;
        document.body.appendChild(script);
    }

    toggle(tab) {
        if (this.state.activeTab !== tab) this.setState({ activeTab: tab });
    }

    handleSearchChanged(e) {
        this.setState({ search: e.target.value });
    }

    handleSearchSubmit(e) {
        e.preventDefault();

        this.componentDidMount();
    }

    handleAddContactClicked = () => {
        this.setState({ addContactDialogOpen: true });
    };

    handleAddContactDialogOpen = () => {
        this.setState({ addContactDialogOpen: true, formOpen: true });
    }

    handleEditContactDialogOpen = () => {
        this.setState({ editContactDialogOpen: true, formOpen: true });
    };

    handleAddContactDialogClose = () => {
        if (this.state.formOpen) {
            if (window.confirm("Are you sure you want to close the Add Contact form?  Any entered information will be lost.")) {
                this.setState({ addContactDialogOpen: false, formOpen: false });
            }
        }
        else {
            this.setState({ addContactDialogOpen: false, formOpen: false });
        }
    };

    handleEditContactClicked = (contactId) => {
        this.setState({ contactId: contactId, editContactDialogOpen: true });
    };

    handleEditContactDialogClose = () => {
        if (this.state.formOpen) {
            if (window.confirm("Are you sure you want to close the Edit Contact form?  Any edited information will be lost.")) {
                this.setState({ editContactDialogOpen: false, formOpen: false });
            }
        }
        else {
            this.setState({ editContactDialogOpen: false, formOpen: false });
        }
    };

    handleContactAdded = (researcher) => {
        this.populateContacts();
        this.setState({ formOpen: false });
    };

    handleAddAnother = () => {
        this.setState({ formOpen: true });
    };

    handleContactDeleted(id) {
        if (!window.confirm('Are you sure you want to delete?')) {
            return;
        }

        var url = 'api/contacts/delete-contact?id=' + id;
        fetch(url).then(response => {
            response.json().then(data => {
                if (response.ok) {
                    this.populateContacts();
                    this.populateDeletedContacts();
                } else {
                    console.error('Submission error', response);
                }
            })
        });
    }

    handleContactRestored(id) {
        var url = 'api/contacts/restore-contact?id=' + id;
        fetch(url).then(response => {
            response.json().then(data => {
                if (response.ok) {
                    this.populateContacts();
                    this.populateDeletedContacts();
                } else {
                    console.error('Submission error', response);
                }
            })
        });
    }

    deleteTabClicked() {
        if (!this.state.deletedContacts) {
            this.populateDeletedContacts();
        }
    }

    renderContactsTable() {
        if (!this.state.contacts || !this.state.contacts.length) {
            var response = "Looks like there aren't any contacts.";

            if (this.state.search) {
                response = (<span>Looks like there aren't any contacts for these search terms: <strong>{this.state.search}</strong></span>);
            } else if (this.state.researcherId) {
                response = "Looks like there aren't any contacts for this researcher.";
            }

            return (<p className="alert alert-warning my-3">{response}</p>);
        };

        return (
            <div>
                <table className="table table-striped my-3 pt-2 dt">
                    <thead>
                        <tr>
                            <th>Date of Contact</th>
                            <th>Date of Resolution</th>
                            <th>Researchers</th>
                            <th>Type of Activity</th>
                            <th>Sub Activity</th>
                            <th width="20%"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.contacts && this.state.contacts.map(contact =>
                            <tr key={contact.id}>
                                <td><span className="d-none">{contact.contactDate}</span>{ContactsTable.formatDate(contact.contactDate)}</td>
                                <td><span className="d-none">{contact.resolutionDate}</span>{ContactsTable.formatDate(contact.resolutionDate)}</td>
                                <td>{contact.persons ? <ul className="list-unstyled m-0">{contact.persons.map(person => <li key={person.id}>{person.name}</li>)}</ul> : <span></span>}</td>
                                <td>{contact.activityType ? contact.activityType.label : <span></span>}</td>
                                <td>{contact.subActivity}</td>
                                <td className="text-right"><button type="button" className="btn btn-info btn-sm" onClick={() => this.handleEditContactClicked(contact.id)} href={'/edit-contact?id=' + contact.id}><FontAwesomeIcon icon="edit" /></button> <button type="button" className="btn btn-danger btn-sm" onClick={() => this.handleContactDeleted(contact.id)}><FontAwesomeIcon icon="trash" /></button></td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        );
    }

    renderDeletedContactsTable() {
        if (!this.state.deletedContacts || !this.state.deletedContacts.length) {
            var response = "Looks like there aren't any deleted contacts.";

            if (this.state.researcherId) {
                response = "Looks like there aren't any deleted contacts for this researcher.";
            }

            return (<p className="alert alert-warning my-3">{response}</p>);
        };

        return (
            <table className="table table-striped my-3">
                <thead>
                    <tr>
                        <th>Date of Contact</th>
                        <th>Date of Resolution</th>
                        <th>Researchers</th>
                        <th>Type of Activity</th>
                        <th width="20%"></th>
                    </tr>
                </thead>
                <tbody>
                    {this.state.deletedContacts && this.state.deletedContacts.map(contact =>
                        <tr key={contact.id}>
                            <td>{ContactsTable.formatDate(contact.contactDate)}</td>
                            <td>{ContactsTable.formatDate(contact.resolutionDate)}</td>
                            <td>{contact.persons ? <ul className="list-unstyled m-0">{contact.persons.map(person => <li key={person.id}>{person.name}</li>)}</ul> : <span></span>}</td>
                            <td>{contact.activityType ? contact.activityType.label : <span></span>}</td>
                            <td className="text-right"><button type="button" className="btn btn-info btn-sm" onClick={() => this.handleEditContactClicked(contact.id)} href={'/edit-contact?id=' + contact.id}><FontAwesomeIcon icon="edit" /></button> <button type="button" className="btn btn-success btn-sm" onClick={() => this.handleContactRestored(contact.id)}><FontAwesomeIcon icon="trash-restore" /></button></td>
                        </tr>
                    )}
                </tbody>
            </table>
        );
    }

    static formatDate(date) {
        if (!date) return '';

        var parsedDate = new Date(date);

        return new Intl.DateTimeFormat('en-US', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
        }).format(parsedDate);
    }

    render() {
        let activeContactsTable = this.state.contacts
            ? this.renderContactsTable()
            : <p className="alert alert-warning">Loading...</p>;
        let deletedContactsTable = this.state.deletedContacts
            ? this.renderDeletedContactsTable()
            : <p className="alert alert-warning">Loading...</p>;

        return (
            <div>
                <form className="form-inline my-4" onSubmit={this.handleSearchSubmit}>
                    <button type="button" className="btn btn-success mb-3 mr-sm-3" onClick={this.handleAddContactClicked}>Add Contact</button>
                    <div className="input-group mb-3 mr-auto">
                        <input id="txtSearch" type="text" className="form-control" aria-label="Search" value={this.state.search} onChange={this.handleSearchChanged} />
                        <div className="input-group-append">
                            <button className="btn btn-outline-secondary" type="submit">Filter</button>
                        </div>
                    </div>
                    <div className="input-group">
                        <a className="btn btn-info mr-2" href="/api/contacts/get-contacts-basic-xlsx" target="_blank">Export Basic</a>
                        <a className="btn btn-info" href="/api/contacts/get-contacts-detailed-xlsx" target="_blank">Export Detailed</a>
                    </div>
                </form>
                <Nav tabs>
                    <NavItem>
                        <NavLink className={classnames({ active: this.state.activeTab === '1' })} onClick={() => { this.toggle('1'); }}>Active</NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink className={classnames({ active: this.state.activeTab === '2' })} onClick={() => { this.toggle('2'); this.deleteTabClicked(); }}>Deleted</NavLink>
                    </NavItem>
                </Nav>
                <TabContent activeTab={this.state.activeTab} className="py-3">
                    <TabPane tabId="1">
                        {activeContactsTable}
                    </TabPane>
                    <TabPane tabId="2">
                        {deletedContactsTable}
                    </TabPane>
                </TabContent>
                <Dialog disableBackdropClick open={this.state.addContactDialogOpen} onEnter={this.handleAddContactDialogOpen} onClose={this.handleAddContactDialogClose} fullWidth={true} maxWidth="lg" aria-labelledby="form-dialog-title">
                    <DialogTitle id="form-dialog-title">Add Contact</DialogTitle>
                    <DialogContent>
                        <ContactForm researcherId={this.state.researcherId} onSubmit={this.handleContactAdded} onAddAnother={this.handleAddAnother} />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleAddContactDialogClose} color="primary">Close</Button>
                    </DialogActions>
                </Dialog>
                <Dialog id="contact-dialog" disableBackdropClick open={this.state.editContactDialogOpen} onEnter={this.handleEditContactDialogOpen} onClose={this.handleEditContactDialogClose} fullWidth={true} maxWidth="lg" aria-labelledby="form-dialog-title">
                    <DialogTitle id="form-dialog-title">Edit Contact</DialogTitle>
                    <DialogContent>
                        <ContactForm contactId={this.state.contactId} onSubmit={this.handleContactAdded} onAddAnother={this.handleAddAnother} />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleEditContactDialogClose} color="primary">Close</Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }

    async populateContacts() {
        const researcherId = this.state.researcherId ? this.state.researcherId : 0;
        const params = new URLSearchParams({ search: this.state.search, researcherId: researcherId });
        const response = await fetch('api/contacts/get-contacts?' + params);
        const data = await response.json();

        if (this.state.dt) {
            this.state.dt.destroy();
        }
        this.setState({ contacts: data });
        this.setState({ dt: window.$("table.dt").DataTable({ order: [], lengthMenu: [[25, 50, 100, -1], [25, 50, 100, "All"]], }) });
    }

    async populateDeletedContacts() {
        const researcherId = this.state.researcherId ? this.state.researcherId : 0;
        const params = new URLSearchParams({ search: this.state.search, researcherId: researcherId, getDeleted: true });
        const response = await fetch('api/contacts/get-contacts?' + params);
        const data = await response.json();

        this.setState({ deletedContacts: data });
    }
}